<script lang="ts">
    import "dayjs/locale/id";
    dayjs.locale("id");
    import "@splidejs/svelte-splide/css/core";
    import Time from "svelte-time";
    import { dayjs } from "svelte-time";
    import { Splide, SplideSlide, SplideTrack } from "@splidejs/svelte-splide";
    import SectionSidebar from "$lib/components/section/News/section-sidebar.svelte";

    export let detail: any;
    export let primaryColor: any;
    export let client: any;
    export let currentPage: any;
    export let detailShared: any;
    export let detailViewed: any;
    export let formShareSocialMedia: any;
    export let categories: any;
    export let news: any;
    export let handleFromShareSocialMedia: any;
</script>

<div class=" lsvr-container flex lg:flex-row flex-col h-max">
    <div class="left-column lg:w-[70%] w-full">
        <!-- MAIN : begin -->
        <main id="main">
            <div class="main__inner">
                <!-- BREADCRUMBS : begin -->
                <div
                    class="breadcrumbs-wrapper flex flex-wrap gap-y-5 justify-between items-center mt-6 mb-8"
                >
                    <div class="breadcrumbs__inner !bg-transparent !p-0">
                        <nav class="breadcrumbs__nav" aria-label="Breadcrumbs">
                            <ul class="breadcrumbs__list">
                                <li class="breadcrumbs__item">
                                    <span
                                        class="breadcrumbs__item-decor"
                                        aria-hidden="true"
                                    />
                                    <a href="/news" class="breadcrumbs__link"
                                        >Berita</a
                                    >
                                </li>

                                <li class="breadcrumbs__item text-slate-600">
                                    <span
                                        class="breadcrumbs__item-decor"
                                        aria-hidden="true"
                                    />
                                    {detail?.title}
                                    <!-- {currentPage} -->
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
                <!-- BREADCRUMBS : end -->

                <!-- POST TITLE & CATEGORY : begin -->
                <div>
                    <h1 class="leading-snug 6xs:text-[24px]">
                        {detail?.title}
                    </h1>
                    <div class="!leading-snug overflow-x-auto mb-4">
                        <Splide
                            class="cursor-grab"
                            options={{
                                gap: "10px",
                                drag: "free",
                                type: "slide",
                                rewind: false,
                                autoWidth: true,
                            }}
                            aria-label="News Categories"
                        >
                            {#if detail?.categories?.data}
                                {#each detail?.categories?.data as post, index}
                                    <SplideSlide>
                                        <a
                                            href="/news/categories/{post?.slug}"
                                            class="categories-item text-slate-700 hover:text-slate-950 block no-underline hover:no-underline rounded-md cursor-pointer transition-opacity duration-200"
                                        >
                                            {post?.name}
                                        </a>
                                    </SplideSlide>
                                {:else}
                                    <!-- <div
                          style="background-color: {primaryColor}; opacity: 0.6"
                          class="categories-item text-[#f0efef] flex items-center gap-1 p-2 rounded-md cursor-pointer transition-opacity duration-200"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" class="mt-[2px]" fill='currentColor' width="18" height="18" aria-label="Tag Category" ><g><path d="M5.653 14.48a1.386 1.386 0 0 0 .985-.408l7.161-7.161a2.309 2.309 0 0 0 .68-1.642V1.391A1.4 1.4 0 0 0 13.085 0H9.21a2.307 2.307 0 0 0-1.642.68L.407 7.841a1.4 1.4 0 0 0 0 1.971l4.261 4.261a1.383 1.383 0 0 0 .985.407ZM13.085.929a.465.465 0 0 1 .465.465v3.875a1.384 1.384 0 0 1-.408.985l-7.161 7.162a.465.465 0 0 1-.657 0l-4.26-4.262a.466.466 0 0 1 0-.657l7.161-7.16A1.386 1.386 0 0 1 9.21.929Z"></path><path d="M10.763 5.11a1.394 1.394 0 1 0-1.394-1.393 1.395 1.395 0 0 0 1.394 1.393Zm0-1.858a.465.465 0 1 1-.465.465.465.465 0 0 1 .465-.465Z"></path></g></svg>
                        <span>
                          Uncategorized
                        </span>
                      </div> -->
                                    <p
                                        class="categories-item text-slate-700 hover:text-slate-950 block no-underline hover:no-underline rounded-md cursor-pointer transition-opacity duration-200"
                                    >
                                        Uncategorized
                                    </p>
                                {/each}
                            {/if}
                            <div class="splide__arrows hidden"></div>
                            <ul class="splide__pagination hidden"></ul>
                        </Splide>
                    </div>
                </div>
                <!-- POST TITLE & CATEGORY : end -->

                <!-- MAIN IMAGE : begin -->
                <div class="main-image main-image--cropped mt-[30px]">
                    <!-- <div class="w-full lg:block hidden lg:h-[350px] 2xl:h-[700px] bg-no-repeat bg-cover" style="background-image: url({detail.featured_images.data?.length > 0 ? detail.featured_images.data[0]?.default : client?.icon});"></div> -->
                    <Splide
                        class="cursor-grab"
                        options={{
                            type: "slide",
                            reducedMotion: {
                                speed: 1200,
                                interval: 6000,
                            },
                        }}
                        hasTrack={false}
                        aria-label="News Images"
                    >
                        <SplideTrack>
                            {#each detail.featured_images.data as image}
                                <SplideSlide>
                                    <div>
                                        <img
                                            loading="lazy"
                                            src={image
                                                ? image?.original
                                                : client?.icon}
                                            alt={`${currentPage} - ${detail?.title}`}
                                            class="w-full object-top aspect-video"
                                        />
                                    </div>
                                </SplideSlide>
                            {/each}
                        </SplideTrack>
                        {#if detail.featured_images.data?.length > 1}
                            <div class="splide__arrows">
                                <button
                                    style="color: {primaryColor};"
                                    class="splide__arrow absolute splide__arrow--prev bg-slate-200 p-2 rounded-full cursor-pointer"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        fill="currentColor"
                                        viewBox="0 0 256 256"
                                        ><path
                                            d="M168.49,199.51a12,12,0,0,1-17,17l-80-80a12,12,0,0,1,0-17l80-80a12,12,0,0,1,17,17L97,128Z"
                                        ></path></svg
                                    >
                                </button>
                                <button
                                    style="color: {primaryColor};"
                                    class="splide__arrow absolute splide__arrow--next bg-slate-200 p-2 rounded-full cursor-pointer"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        fill="currentColor"
                                        viewBox="0 0 256 256"
                                        ><path
                                            d="M184.49,136.49l-80,80a12,12,0,0,1-17-17L159,128,87.51,56.49a12,12,0,1,1,17-17l80,80A12,12,0,0,1,184.49,136.49Z"
                                        ></path></svg
                                    >
                                </button>
                            </div>
                        {:else}
                            <div class="splide__arrows hidden"></div>
                        {/if}
                        <ul class="splide__pagination hidden"></ul>
                    </Splide>
                </div>
                <!-- MAIN IMAGE : end -->

                <!-- MAIN CONTENT : begin -->
                <div class="main__content">
                    <div class="main__content-wrapper">
                        <div
                            class="main__content-inner lg:!mb-[90px] !mb-[40px]"
                        >
                            <!-- POST SINGLE : begin -->
                            <div class="post-single blog-post-single">
                                <!-- POST : begin -->
                                <article class="post">
                                    <div class="post__inner">
                                        <!-- MAIN HEADER : begin -->
                                        <header>
                                            <div
                                                class="main-header__inner mt-3"
                                            >
                                                <!-- POST AUTHOR : begin -->
                                                <div
                                                    class="text-[#333] font-semibold !leading-snug mb-1"
                                                >
                                                    <span
                                                        class=" pointer-events-none"
                                                    >
                                                        {#if detail?.author}
                                                            {detail?.author}
                                                        {:else}
                                                            Admin
                                                        {/if}
                                                    </span>
                                                </div>
                                                <!-- POST AUTHOR : end -->

                                                <!-- POST DATE : begin -->
                                                <div
                                                    class="text-[#606066] text-[14px] font-normal !leading-snug"
                                                >
                                                    <Time
                                                        timestamp={detail?.published_at}
                                                        format={`D MMMM YYYY HH:mm`}
                                                    />
                                                    {new Date(
                                                        detail?.published_at,
                                                    )
                                                        .toLocaleString(
                                                            "id-ID",
                                                            {
                                                                hour: "numeric",
                                                                minute: "2-digit",
                                                                hour12: false,
                                                                timeZoneName:
                                                                    "short",
                                                            },
                                                        )
                                                        ?.split(" ")?.[1]}
                                                    <!-- {`${ (Intl.DateTimeFormat(undefined, {timeZoneName: 'longGeneric'})?.formatToParts(new Date(detail?.published_at))?.find((part) => part?.type == 'timeZoneName')?.value) === 'Western Indonesia Time' ? 'WIB' : (Intl.DateTimeFormat(undefined, {timeZoneName: 'longGeneric'})?.formatToParts(new Date(detail?.published_at))?.find((part) => part?.type == 'timeZoneName')?.value) === 'Eastern Indonesia Time' ? 'WIT' : 'WITA' }`} -->
                                                </div>
                                                <!-- POST DATE : end -->

                                                <!-- POST DATE : begin -->
                                                <div
                                                    class="container-information-content flex flex-wrap items-center justify-between mt-3 mb-2 border-b border-solid border-[#F2F2F2 pb-4 gap-y-4"
                                                >
                                                    <div
                                                        class="wrapper-viewed-shared flex flex-wrap items-center gap-x-4 gap-y-3"
                                                    >
                                                        <div
                                                            class="viewed-count flex items-center gap-[6px] rounded-[10px] text-[#606066] font-normal"
                                                        >
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                class="text-gray-500"
                                                                width="22"
                                                                height="22"
                                                                viewBox="0 0 24 24"
                                                                ><path
                                                                    fill="currentColor"
                                                                    d="M12 3c5.392 0 9.878 3.88 10.819 9c-.94 5.12-5.427 9-10.819 9c-5.392 0-9.878-3.88-10.818-9C2.122 6.88 6.608 3 12 3m0 16a9.005 9.005 0 0 0 8.778-7a9.005 9.005 0 0 0-17.555 0A9.005 9.005 0 0 0 12 19m0-2.5a4.5 4.5 0 1 1 0-9a4.5 4.5 0 0 1 0 9m0-2a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5"
                                                                /></svg
                                                            >
                                                            <span
                                                                >{!detailViewed
                                                                    ? 0
                                                                    : new Intl.NumberFormat().format(
                                                                          detailViewed,
                                                                      )} kali dilihat</span
                                                            >
                                                        </div>
                                                        <div
                                                            class="viewed-count flex items-center gap-[6px] rounded-[10px] text-[#606066] font-normal"
                                                        >
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                class="text-gray-500"
                                                                width="22"
                                                                height="22"
                                                                viewBox="0 0 24 24"
                                                                ><path
                                                                    fill="currentColor"
                                                                    d="m13.12 17.023l-4.199-2.29a4 4 0 1 1 0-5.465l4.2-2.29a4 4 0 1 1 .958 1.755l-4.2 2.29a4.008 4.008 0 0 1 0 1.954l4.2 2.29a4 4 0 1 1-.959 1.755M6 14a2 2 0 1 0 0-4a2 2 0 0 0 0 4m11-6a2 2 0 1 0 0-4a2 2 0 0 0 0 4m0 12a2 2 0 1 0 0-4a2 2 0 0 0 0 4"
                                                                /></svg
                                                            >
                                                            <span
                                                                >{!detailShared
                                                                    ? 0
                                                                    : new Intl.NumberFormat().format(
                                                                          detailShared,
                                                                      )} kali dibagikan</span
                                                            >
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="wrapper-content-share"
                                                    >
                                                        <!-- <Tooltip
                                    style={{
                                      style: {
                                        zIndex: 1000,
                                      }
                                    }}
                                    animation="fade"
                                    position="top"
                                    content={`Bagikan`}
                                    theme='custom-tooltip'
                                  >
                                    <button class='share-button flex gap-x-2 rounded-[8px] transition-colors duration-200 cursor-pointer'  on:click={() => {
                                      formShareSocialMedia = true;
                                      document.body.style.overflow = 'hidden'
                                    }}>
                                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="m13.12 17.023l-4.199-2.29a4 4 0 1 1 0-5.465l4.2-2.29a4 4 0 1 1 .958 1.755l-4.2 2.29a4.008 4.008 0 0 1 0 1.954l4.2 2.29a4 4 0 1 1-.959 1.755M6 14a2 2 0 1 0 0-4a2 2 0 0 0 0 4m11-6a2 2 0 1 0 0-4a2 2 0 0 0 0 4m0 12a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/></svg>
                                    </button>
                                  </Tooltip> -->
                                                        <button
                                                            class="share-button flex gap-x-2 rounded-[8px] transition-colors duration-200 cursor-pointer border border-[#F2F2F2] p-2 hover:text-opacity-80"
                                                            on:click={() => {
                                                                formShareSocialMedia = true;
                                                                handleFromShareSocialMedia();
                                                                document.body.style.overflow =
                                                                    "hidden";
                                                            }}
                                                        >
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                class="text-gray-500"
                                                                width="22"
                                                                height="22"
                                                                viewBox="0 0 24 24"
                                                                ><path
                                                                    fill="currentColor"
                                                                    d="m13.12 17.023l-4.199-2.29a4 4 0 1 1 0-5.465l4.2-2.29a4 4 0 1 1 .958 1.755l-4.2 2.29a4.008 4.008 0 0 1 0 1.954l4.2 2.29a4 4 0 1 1-.959 1.755M6 14a2 2 0 1 0 0-4a2 2 0 0 0 0 4m11-6a2 2 0 1 0 0-4a2 2 0 0 0 0 4m0 12a2 2 0 1 0 0-4a2 2 0 0 0 0 4"
                                                                /></svg
                                                            >
                                                            <span>Bagikan</span>
                                                        </button>
                                                    </div>
                                                </div>
                                                <!-- POST DATE : end -->
                                            </div>
                                        </header>
                                        <!-- MAIN HEADER : end -->

                                        <!-- POST CONTENT : begin -->
                                        <div class="post__content pt-[20px]">
                                            {#if detail?.content}
                                                <p class="text-[18px]">
                                                    {@html detail?.content}
                                                </p>
                                            {:else}
                                                <p>Tidak ada deskripsi</p>
                                            {/if}
                                        </div>
                                        <!-- POST CONTENT : end -->

                                        <!-- POST SOURCE NEWS : begin -->
                                        {#if !!detail?.source}
                                            <div class="text-[14px]">
                                                <span>
                                                    <span
                                                        class="text-[#606066]"
                                                    >
                                                        Sumber :
                                                    </span>
                                                    <a
                                                        class="font-semibold italic text-slate-800 no-underline"
                                                        href={`${detail?.source}`}
                                                        >{new URL(
                                                            detail?.source,
                                                        )?.hostname +
                                                            new URL(
                                                                detail?.source,
                                                            )?.pathname}</a
                                                    >
                                                </span>
                                            </div>
                                        {/if}
                                        <!-- POST SOURCE NEWS : begin -->
                                    </div>
                                </article>
                                <!-- POST : end -->
                            </div>
                            <!-- POST SINGLE : end -->
                        </div>
                    </div>
                </div>
                <!-- MAIN CONTENT : begin -->
            </div>
        </main>
        <!-- MAIN : end -->
    </div>

    <!-- sticky top-[6rem] self-start -->
    <div class="right-column lg:w-[30%] w-full lg:pl-[30px] min-h-max">
        <div class="sticky top-28">
            <div
                class="wrapper-categories bg-[#f0f0f0c2]/50 rounded-[12px] mt-6 px-3 pb-3"
            >
                <div class="flex items-center gap-2">
                    <div
                        style="background-color: {primaryColor};"
                        class="w-[4px] h-[10px] rounded-[12px]"
                    ></div>
                    <span
                        class="text-[20px] text-slate-800 font-medium block py-3"
                        >Kategori</span
                    >
                </div>
                {#if categories?.length > 0}
                    <Splide
                        class="cursor-grab"
                        options={{
                            gap: "10px",
                            wheel: true,
                            drag: "free",
                            type: "slide",
                            rewind: false,
                            autoWidth: true,
                            wheelSleep: 200,
                            waitForTransition: true,
                        }}
                        aria-label="News Categories"
                    >
                        {#each categories as category}
                            <SplideSlide>
                                <a
                                    href={`/news/categories/${category?.slug}`}
                                    class="item-category no-underline hover:no-underline bg-slate-200 hover:bg-slate-300/80 rounded-[10px] transition-colors duration-200 flex items-center gap-1 px-2 py-1"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        class="mt-[2px]"
                                        width="18"
                                        height="18"
                                        aria-label="Tag Category"
                                        ><g
                                            ><path
                                                d="M5.653 14.48a1.386 1.386 0 0 0 .985-.408l7.161-7.161a2.309 2.309 0 0 0 .68-1.642V1.391A1.4 1.4 0 0 0 13.085 0H9.21a2.307 2.307 0 0 0-1.642.68L.407 7.841a1.4 1.4 0 0 0 0 1.971l4.261 4.261a1.383 1.383 0 0 0 .985.407ZM13.085.929a.465.465 0 0 1 .465.465v3.875a1.384 1.384 0 0 1-.408.985l-7.161 7.162a.465.465 0 0 1-.657 0l-4.26-4.262a.466.466 0 0 1 0-.657l7.161-7.16A1.386 1.386 0 0 1 9.21.929Z"
                                            ></path><path
                                                d="M10.763 5.11a1.394 1.394 0 1 0-1.394-1.393 1.395 1.395 0 0 0 1.394 1.393Zm0-1.858a.465.465 0 1 1-.465.465.465.465 0 0 1 .465-.465Z"
                                            ></path></g
                                        ></svg
                                    >
                                    <span
                                        class="text-[14px] font-semibold text-slate-700"
                                        >{category?.name}</span
                                    >
                                </a>
                            </SplideSlide>
                        {/each}
                        <div class="splide__arrows hidden"></div>
                        <ul class="splide__pagination"></ul>
                    </Splide>
                {:else}
                    <div
                        class="item-category w-max flex items-center gap-1 px-2 py-1 bg-slate-200 hover:bg-slate-300/80 rounded-[10px] transition-colors duration-200"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            aria-label="Uncategorized"
                            class="FollowingTag-addTagIcon-KCc e2e-FollowingTag-AddIcon"
                            ><g
                                ><path
                                    d="M5.653 14.48a1.386 1.386 0 0 0 .985-.408l7.161-7.161a2.309 2.309 0 0 0 .68-1.642V1.391A1.4 1.4 0 0 0 13.085 0H9.21a2.307 2.307 0 0 0-1.642.68L.407 7.841a1.4 1.4 0 0 0 0 1.971l4.261 4.261a1.383 1.383 0 0 0 .985.407ZM13.085.929a.465.465 0 0 1 .465.465v3.875a1.384 1.384 0 0 1-.408.985l-7.161 7.162a.465.465 0 0 1-.657 0l-4.26-4.262a.466.466 0 0 1 0-.657l7.161-7.16A1.386 1.386 0 0 1 9.21.929Z"
                                ></path><path
                                    d="M10.763 5.11a1.394 1.394 0 1 0-1.394-1.393 1.395 1.395 0 0 0 1.394 1.393Zm0-1.858a.465.465 0 1 1-.465.465.465.465 0 0 1 .465-.465Z"
                                ></path></g
                            ><g transform="translate(7.75 4.919)"
                                ><circle
                                    cx="5.5"
                                    cy="5.5"
                                    r="5.5"
                                    transform="translate(.587 .002)"
                                    fill="#f5f8ff"
                                ></circle><path
                                    d="M6.087 1.003a4.5 4.5 0 1 0 4.5 4.5 4.5 4.5 0 0 0-4.5-4.5Zm2.812 4.781a.281.281 0 0 1-.281.281H6.649v1.969a.281.281 0 0 1-.281.281h-.562a.281.281 0 0 1-.281-.281V6.065H3.556a.281.281 0 0 1-.281-.281v-.562a.281.281 0 0 1 .281-.281h1.968V2.972a.281.281 0 0 1 .281-.281h.563a.281.281 0 0 1 .281.281V4.94h1.969a.281.281 0 0 1 .281.281Z"
                                ></path></g
                            ></svg
                        >
                        <span class="text-[14px] font-semibold text-slate-700"
                            >Uncategorized</span
                        >
                    </div>
                {/if}
            </div>
            <div
                class="wrapper-other-news bg-[#f0f0f0c2]/50 rounded-[12px] mt-6 px-3"
            >
                <div class="flex items-center gap-2">
                    <div
                        style="background-color: {primaryColor};"
                        class="w-[4px] h-[10px] rounded-[12px]"
                    ></div>
                    <span
                        class="text-[20px] text-slate-800 font-medium block py-3"
                        >{currentPage} Lainnya</span
                    >
                </div>
                <div class="list-news-wrapper pb-3 lg:mb-0 mb-5">
                    <!-- LIST : begin -->
                    <SectionSidebar data={news} data_detail={detail} />
                    <!-- LIST : end -->
                    <div class="mt-[20px] flex justify-end">
                        <a
                            href="/news"
                            class="flex flex-wrap gap-2 ml-auto px-3 py-2 !no-underline shadow-sm text-slate-600 bg-[#ffff] rounded-[6px] font-semibold duration-200 group"
                        >
                            <span>Lihat Semua</span>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="group-hover:translate-x-1 transition-transform text-slate-400"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                ><path
                                    fill="currentColor"
                                    d="m16.172 11l-5.364-5.364l1.414-1.414L20 12l-7.778 7.778l-1.414-1.414L16.172 13H4v-2z"
                                /></svg
                            >
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
